var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"isMobileMenuOpen":_vm.isMobileMenuOpen,"isMobileSearchOpen":_vm.isMobileSearchOpen,"toggleMobileMenu":_vm.toggleMobileMenu,"toggleMobileSearch":_vm.toggleMobileSearch})],2)}
var staticRenderFns = []

export { render, staticRenderFns }